import { Eye, EyeOff } from "lucide-react";
import {
  ChefHat,
  Package,
  CreditCard,
  Bot,
  Users,
  Settings,
  Bell,
  QrCode,
  TimerReset,
  Circle,
  TableProperties,
  ShoppingBag,
  Tag,
  Volume2,
  Check,
  Printer,
Clock,
Gamepad2,
Sparkles,
MessageCircle
} from "lucide-react";

// 🎯 STANDARD UNICO
const baseProps = {
  strokeWidth: 1.5
};

// 🎨 COLORI UX (iOS style)
export const iconColors = {
  primary: "#0a84ff",
  success: "#30d158",
  warning: "#ff9f0a",
  danger: "#ff3b30",
  ai: "#8b5cf6",
  neutral: "#e5e7eb"
};

// 🧩 SIZE UNIFICATI
const SMALL = 18;
const MEDIUM = 22;
const BIG = 32;

// 🧩 MAPPA ICONE (versione definitiva)
export const Icons = {
  eye: (props) => <Eye size={SMALL} {...baseProps} {...props} />,
  eyeOff: (props) => <EyeOff size={SMALL} {...baseProps} {...props} />,
  menu: (props) => <ChefHat size={MEDIUM} {...baseProps} {...props} />, 
  ordini: (props) => <Package size={MEDIUM} {...baseProps} {...props} />, 
  cassa: (props) => <CreditCard size={MEDIUM} {...baseProps} {...props} />, 

  ai: (props) => <Bot size={SMALL} {...baseProps} {...props} />,
  qira: (props) => (
  <Sparkles size={MEDIUM} {...baseProps} {...props} />
),

games: (props) => (
  <Gamepad2 size={MEDIUM} {...baseProps} {...props} />
),

chat: (props) => (
  <MessageCircle size={BIG} {...baseProps} {...props} />
),
  training: (props) => <Users size={SMALL} {...baseProps} {...props} />,
  users: (props) => <Users size={MEDIUM} {...baseProps} {...props} />, 
cameriere: (props) => <Users size={SMALL} {...baseProps} {...props} />,
simulate: (props) => <Bot size={SMALL} {...baseProps} {...props} />,
  settings: (props) => <Settings size={SMALL} {...baseProps} {...props} />,

  bell: (props) => <Bell size={SMALL} {...baseProps} {...props} />,
  cucina: (props) => <ChefHat size={SMALL} {...baseProps} {...props} />,
  kitchen: (props) => <ChefHat size={SMALL} {...baseProps} {...props} />,
  qr: (props) => <QrCode size={SMALL} {...baseProps} {...props} />,

  print: (props) => <Printer size={18} {...baseProps} {...props} />, 
  clock: (props) => <Clock size={SMALL} {...baseProps} {...props} />, 
  timer: (props) => <TimerReset size={SMALL} {...baseProps} {...props} />,
  circle: (props) => <Circle size={SMALL} {...baseProps} {...props} />,
  table: (props) => <TableProperties size={SMALL} {...baseProps} {...props} />,
  takeaway: (props) => <ShoppingBag size={SMALL} {...baseProps} {...props} />,
  category: (props) => <Tag size={SMALL} {...baseProps} {...props} />,
  volume: (props) => <Volume2 size={SMALL} {...baseProps} {...props} />,
  check: (props) => <Check size={SMALL} {...baseProps} {...props} />
};